import {useEffect, useState} from "react";
import back_arrow from "../assets/backarrow.svg";
import SummaryGraphical from "../components/SummaryGraphical";
import SummaryTabular from "../components/SummaryTabular";
import SummaryProgramme from "../components/SummaryProgramme";
import CoachCommentaryContainer from "../components/CoachCommentaryContainer";


const SummaryPillars = (props) => {
    const surveyData = props.surveyData;
    const generatingReport = props.generatingReport;
    const coachingSpacer = props.coachingSpacer;
    const subscription = props.subscription;

    const cardType = props.cardType;
    const [cardData, setCardData] = useState();

    useEffect(() => {
        if (!surveyData || cardType === undefined) return;
        setCardData(surveyData.pillars[cardType]);
    }, [surveyData, cardType]);

    const handleBackClick = () => {
        props.back(cardType);
    }

    const getTitle = () => {
        switch (cardType) {
            case 0: return "Purpose & Motivation";
            case 1: return "External Systems & Processes";
            case 2: return "Relationships";
            case 3: return "Internal Systems & Processes";
            case 4: return "Learning";
            case 5: return "Leadership";
            default: return "Summary";
        }
    }

    return (
        <>
            <div className="link" onClick={handleBackClick} style={{display: generatingReport ? "none" : null}}>
                <img className={"back-arrow-classname"} src={back_arrow} alt="Back Arrow"/>
            </div>
            <div className="summary-title"
                 style={{marginLeft: generatingReport ? "30px" : null, padding: generatingReport ? "unset" : null}}>
                {getTitle()}
            </div>
            <div className="summary-top-5-container">
                <div className="summary-pillar-controls-container" style={{display: generatingReport ? "none" : null}}>
                    <div className={`summary-pillar-control-button link pillar-blue ${cardType === 0 ? "active" : ""}`}
                         onClick={() => props.switchMenu(0)}
                    />
                    <div className={`summary-pillar-control-button link pillar-red ${cardType === 1 ? "active" : ""}`}
                         onClick={() => props.switchMenu(1)}
                    />
                    <div className={`summary-pillar-control-button link pillar-green ${cardType === 2 ? "active" : ""}`}
                         onClick={() => props.switchMenu(2)}
                    />
                    <div className={`summary-pillar-control-button link pillar-purple ${cardType === 3 ? "active" : ""}`}
                         onClick={() => props.switchMenu(3)}
                    />
                    <div className={`summary-pillar-control-button link pillar-pink ${cardType === 4 ? "active" : ""}`}
                         onClick={() => props.switchMenu(4)}
                    />
                    <div className={`summary-pillar-control-button link pillar-orange ${cardType === 5 ? "active" : ""}`}
                         onClick={() => props.switchMenu(5)}
                    />
                </div>
                <div className="summary-top-5-body-container" style={{width: generatingReport ? "100%" : null}}>
                    {!props.hideGraphical ?
                        <>
                            <SummaryGraphical cardData={cardData} generatingReport={generatingReport} subscription={subscription} />
                            <CoachCommentaryContainer context_id={props.surveyID} generatingReport={generatingReport}
                                                      section_id={`pillar-graphical-${cardType}`} demo={props.demo}
                                                      subscription={subscription}/>
                        </> : null
                    }
                    {!props.hideTabular ?
                        <>
                            <SummaryTabular cardData={cardData} surveyData={surveyData}
                                            origin={"chart"}
                                            showQuestions={true}
                                            cardType={cardType} seeQuestions={props.seeQuestions.bind(this)}
                                            generatingReport={generatingReport}
                                            subscription={subscription}/>
                            <CoachCommentaryContainer context_id={props.surveyID} generatingReport={generatingReport}
                                                      section_id={`pillar-tabular-${cardType}`} demo={props.demo}
                                                      subscription={subscription}/>
                        </> : null
                    }
                    {!props.hideProgramme ?
                        <>
                            <div className="pdf-spacer" style={{height: coachingSpacer, display: generatingReport ? "block" : "none"}}/>
                            <SummaryProgramme programmes={surveyData?.pillars[cardType]?.coaching_programme}
                                              cardType={cardType} generatingReport={generatingReport}
                                              hideExercises={props.hideExercise}/>
                            <CoachCommentaryContainer context_id={props.surveyID} generatingReport={generatingReport}
                                                      section_id={`pillar-programme-${cardType}`} demo={props.demo}
                                                      subscription={subscription}/>
                        </> : null
                    }
                </div>
            </div>
        </>
    )
}

export default SummaryPillars